import { ConditionalTooltip } from 'ui/common/tooltip/conditional-tooltip';
import { Link } from 'app/area/links-section/types-store';
import { isObjectEmpty } from 'app/infrastructure/data/object';
import * as React from 'react';
import styles from './links-groups.scss';

interface LinkProps {
  link: Link;
}

export function LinkComponent({ link }: LinkProps) {

  if (!link || isObjectEmpty(link)) {
    return null;
  }

  return (
    <ConditionalTooltip title={link.longDescription} className={styles.link} narrow={true} show={!!link.longDescription}>
      <a href={link.url} target="_blank" rel="noopener noreferrer">
        <div>
          {link.description}
        </div>
      </a>
    </ConditionalTooltip>
  );
}
